/* eslint-disable import/extensions */
import { IdleQueue } from 'idlize/IdleQueue.mjs'
import Router from '@titanio/router'

const loader = () => {
  const queue = new IdleQueue()
  const router = new Router()

  router.get(['/:slug/', '/seguranca-digital-144/:slug/'], () => {
    import(
      /* webpackChunkName: "postblog" */
      '@pages/postblog'
    ).then((page) => {
      page.default.mount()
    })
  })

  router.get('/seguranca-digital-144/autor/:slug/', () => {
    import(
      /* webpackChunkName: "author" */
      '@pages/author'
    ).then((page) => {
      page.default.mount()
    })
  })

  queue.pushTask(() => router.init())
}

export default { loader }
